/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql, withPrefix } from "gatsby";

const SEO = ({
  description,
  lang,
  meta,
  title,
  image,
  isFirst,
  isLast,
  prevPage,
  nextPage,
  uri,
}) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `
  );

  const metaDescription = description
    ? description
    : site.siteMetadata.description;
  const defaultTitle = site.siteMetadata?.title;
  return (
    <>
      <title>{defaultTitle ? `${title} | ${defaultTitle}` : title}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={site.siteMetadata?.author || ""} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />

      <meta
        property="og:image"
        content={image ? image : "https://spokojwglowie.pl/og-image.jpg"}
      />

      {!isFirst && (
        <link rel="prev" href={`https://spokojwglowie.pl${prevPage}`} />
      )}
      {!isLast && (
        <link
          rel="next"
          href={`https://spokojwglowie.pl${uri}page/${nextPage}`}
        />
      )}
    </>
  );
};

SEO.defaultProps = {
  lang: `pl`,
  meta: [],
  description: ``,
  image: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
};

export default SEO;
